import React from 'react'

const ChatHistory = () => {
  const chatData = [
    {
      'historyHeader': 'I need to know about opening a new saving account here',
      'historyDate': '21 Apr',
      'HistroyTime': '10:02 AM',
      'historySocials': <span className="tlk tlknew-whatsapp"></span>
    },
    {
      'historyHeader': 'How to enroll in paperless statements',
      'historyDate': '21 Apr',
      'HistroyTime': '10:02 AM',
      'historySocials': ''
    },
    {
      'historyHeader': 'Order Checks or request a new debit card',
      'historyDate': '21 Apr',
      'HistroyTime': '10:02 AM',
      'historySocials': ''
    },
    {
      'historyHeader': 'Learning our savings or investments options',
      'historyDate': '21 Apr',
      'HistroyTime': '10:02 AM',
      'historySocials': ''
    },
    {
      'historyHeader': 'Credit Card offerings',
      'historyDate': '21 Apr',
      'HistroyTime': '10:02 AM',
      'historySocials': ''
    },
    {
    'historyHeader': 'Setting up a direct deposit',
    'historyDate': '21 Apr',
      'HistroyTime': '10:02 AM',
      'historySocials': ''
    },
    {
      'historyHeader': 'Transfers funds between accounts',
      'historyDate': '21 Apr',
      'HistroyTime': '10:02 AM',
      'historySocials': ''
    },
  ]
  return (
    <div className='chat-history-wrapper'>
      <div className='chat-history-iwrp'>
        <div className='chat-history-header'>
          <h5>Chat History</h5>
          <div className='ch-header-actions'>
            <div>
              <span className='tlknew tlknew-search'></span>
            </div>
            <div>
              <span className='tlknew tlknew-filter'></span>
              Filter</div>
          </div>
        </div>

        {chatData.map((item, index) => (
          <div className='chat-history-data' key={index}>
            <div className='chat-history-data-items'>
              <h6>{item.historyHeader}</h6>
              <div className='ch-data-items-time-socials'>
                <div>{item.historyDate} || {item.HistroyTime}</div>
                <div>{item.historySocials}</div>
              </div>
            </div>
          </div>
        ))}

      </div>
    </div>
  )
}

export default ChatHistory
